




import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Icon extends Vue {
  @Prop() private icon!: string

  get name() {
    return this.icon.toLocaleLowerCase()
  }

  get iconClasses() {
    return [
      'icon',
      `icon--${this.name}`,
    ]
  }
}
